class IpCheck {
  static COOKIE_EXPIRY_TIME = 30 * 24 * 60 * 60 * 1000;

  async init(context) {
    this.context = context;
    this.ipData = {};
    this.currentSite = null;
    this.targetCountry = null;

    const pathname = window.location.pathname;
    const isHomepage = pathname === '/' || pathname === '' || pathname === '/index';
    if (!isHomepage) {
      console.log('IP Check: skipped (not homepage)');
      return;
    }

    const hostName = window.location.host;
    const hasLocalData = this.checkExpiredData();
    if (hasLocalData) {
      console.log('IP Check: skipped (cookie exists)');
      return;
    }

    const siteConfigs = this.getSiteConfigs();
    let currentSiteConfig = siteConfigs.find(config => 
      hostName.includes(config.url) || hostName === config.url
    );

    if (!currentSiteConfig && (hostName.includes('preview') || hostName.includes('myshopify') || hostName.includes('shopifypreview'))) {
      const fullUrl = window.location.href;
      
      if (fullUrl.includes('miradoroutdoor.eu') || fullUrl.includes('.eu')) {
        currentSiteConfig = siteConfigs.find(config => config.name === 'EU');
      } else if (fullUrl.includes('miradoroutdoor.com') || fullUrl.includes('.com')) {
        currentSiteConfig = siteConfigs.find(config => config.name === 'US');
      }
      
      if (!currentSiteConfig && document.body) {
        const pageText = document.body.innerText ? document.body.innerText.toLowerCase() : '';
        const pageHtml = document.documentElement ? document.documentElement.innerHTML.toLowerCase() : '';
        
        if (pageText.includes('mirador eu') || 
            pageText.includes('support@miradoroutdoor.de') ||
            pageText.includes('dresden') ||
            pageHtml.includes('miradoroutdoor.eu') ||
            pageText.includes('deutsch') ||
            pageText.includes('germany')) {
          currentSiteConfig = siteConfigs.find(config => config.name === 'EU');
        } else if (pageText.includes('miradoroutdoor.com') || 
                    pageText.includes('united states') ||
                    pageHtml.includes('miradoroutdoor.com')) {
          currentSiteConfig = siteConfigs.find(config => config.name === 'US');
        }
      }
      
      if (!currentSiteConfig) {
        if (hostName.includes('.eu') || hostName.includes('eu')) {
          currentSiteConfig = siteConfigs.find(config => config.name === 'EU');
        } else {
          currentSiteConfig = siteConfigs.find(config => config.name === 'US');
        }
      }
    }

    if (!currentSiteConfig) {
      console.log('IP Check: current site not recognized, skipping', {
        hostName: hostName
      });
      this.setDataWithExpiry();
      return;
    }

    this.currentSite = currentSiteConfig;
    await this.getIpCountry();
    this.processIpData();
  }

  getSiteConfigs() {
    return [
      {
        name: 'US',
        url: 'miradoroutdoor.com',
        country_name: 'United States',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/all/assets/us-YZEEIF9XYc5z.svg',
        countryCodes: ['US', 'CA', 'MX'], 
        checkInEu: false
      },
      {
        name: 'DE',
        url: 'miradoroutdoor.eu/de',
        country_name: 'Germany',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/de-QIkpdT_kUNZ6.svg',
        countryCodes: ['DE'],
        checkInEu: true
      },
      {
        name: 'FR',
        url: 'miradoroutdoor.eu/fr',
        country_name: 'France',
        logo: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fr-CvJDduywicne.svg',
        countryCodes: ['FR'],
        checkInEu: true
      },
      {
        name: 'EU',
        url: 'miradoroutdoor.eu',
        country_name: 'European',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b7/Flag_of_Europe.svg',
        countryCodes: ['PT', 'BE', 'AT', 'CH', 'SE', 'NO', 'DK', 'FI', 'PL', 'CZ', 'HU', 'RO', 'BG', 'HR', 'SI', 'SK', 'LT', 'LV', 'EE', 'LU', 'MT', 'CY', 'IE', 'GR', 'IT', 'ES', 'NL', 'GB', 'UK'],
        checkInEu: true
      }
    ];
  }

  processIpData() {
    const siteConfigs = this.getSiteConfigs();
    
    if (!this.ipData.country_code) {
      console.log('IP Check: no country code found, skipping redirect');
      this.setDataWithExpiry();
      return;
    }

    const countryCode = (this.ipData.country_code || '').toUpperCase();

    for (const config of siteConfigs) {
      const isExactMatch = config.countryCodes.includes(countryCode);
      let shouldRedirect = false;
      
      if (isExactMatch) {
        // 精确匹配，直接使用该配置
        shouldRedirect = true;
      } else if (config.name === 'EU' && config.checkInEu) {
        // 只有EU配置在没有精确匹配时，才使用in_eu标志
        shouldRedirect = this.ipData.in_eu === true;
      }

      if (shouldRedirect) {
        if (this.currentSite && this.currentSite.name === config.name) {
          console.log('IP Check: already on correct site', {
            currentSite: this.currentSite.name,
            ipCountry: countryCode
          });
          this.setDataWithExpiry();
          return;
        }
        
        console.log('IP Check: redirecting to matched site', {
          currentSite: this.currentSite?.name,
          targetSite: config.name,
          ipCountry: countryCode
        });
        this.targetCountry = config;
        this.showRedirectModal();
        return;
      }
    }

    // 如果IP不匹配任何配置，且当前站点不是美国站，则显示跳转到美国站的弹框
    if (this.currentSite && this.currentSite.name !== 'US') {
      const usConfig = siteConfigs.find(config => config.name === 'US');
      if (usConfig) {
        console.log('IP Check: redirecting to US (non-matching IP from non-US site)', {
          currentSite: this.currentSite.name,
          ipCountry: countryCode
        });
        this.targetCountry = usConfig;
        this.showRedirectModal();
        return;
      }
    }
    
    console.log('IP Check: no redirect needed', {
      currentSite: this.currentSite?.name,
      ipCountry: countryCode
    });
    this.setDataWithExpiry();
  }

  getIpCountry() {
    return new Promise((resolve) => {
      fetch('https://ipapi.co/json/')
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          this.ipData = data;
          
          if (!this.ipData.country_code && this.ipData.country) {
            this.ipData.country_code = this.ipData.country;
          }
          
          console.log('IP Check result:', {
            ip: this.ipData.ip,
            country_code: this.ipData.country_code,
            country_name: this.ipData.country_name
          });
          
          resolve(data);
        })
        .catch(error => {
          console.error('IP Check API error:', error);
          this.ipData = {};
          console.log('IP Check result:', {
            ip: null,
            country_code: null,
            country_name: null,
            error: error.message
          });
          resolve({});
        });
    });
  }

  checkExpiredData() {
    const cookies = document.cookie.split(';').filter(c => c.trim());
    
    const ipCheckedCookie = cookies.find(cookie => 
      cookie.trim().startsWith('ipChecked=')
    );
    
    if (!ipCheckedCookie) {
      console.log('IP Check: cookie not found');
      return false;
    }
    
    try {
      const cookieValue = ipCheckedCookie.split('=')[1];
      const data = JSON.parse(decodeURIComponent(cookieValue));
      
      if (data.checked !== true) {
        console.log('IP Check: cookie found but checked flag is not true');
        return false;
      }
      
      const now = Date.now();
      const cookieTime = data.timestamp || 0;
      const expireTime = cookieTime + IpCheck.COOKIE_EXPIRY_TIME;
      const createDate = new Date(cookieTime);
      const expireDate = new Date(expireTime);
      
      if (now - cookieTime > IpCheck.COOKIE_EXPIRY_TIME) {
        console.log('IP Check: cookie expired, removed');
        this.removeCookie();
        return false;
      }
      
      console.log('IP Check: cookie found', {
        created_at: createDate.toISOString(),
        expires_at: expireDate.toISOString()
      });
      
      return true;
    } catch (error) {
      console.log('IP Check: cookie parse error, removed');
      this.removeCookie();
      return false;
    }
  }

  setDataWithExpiry() {
    const data = {
      checked: true,
      timestamp: Date.now()
    };
    
    const expires = new Date();
    expires.setTime(expires.getTime() + IpCheck.COOKIE_EXPIRY_TIME);
    
    document.cookie = `ipChecked=${encodeURIComponent(JSON.stringify(data))};expires=${expires.toUTCString()};path=/`;
  }

  removeCookie() {
    document.cookie = 'ipChecked=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
  }

  getCurrentSiteLogo() {
    if (this.currentSite && this.currentSite.logo) {
      return this.currentSite.logo;
    }
    
    if (window.shopifyLogoUrl) {
      return window.shopifyLogoUrl;
    }
    
    const logoImg = document.querySelector('.header__logo img');
    if (logoImg && logoImg.src) {
      return logoImg.src;
    }
    
    return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZjU5ZTBiIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Im0yMS43MyAxOC04LTE0YTIgMiAwIDAgMC0zLjQ4IDBsLTggMTRBMiAyIDAgMCAwIDQgMjFoMTZhMiAyIDAgMCAwIDEuNzMtM1oiPjwvcGF0aD48bGluZSB4MT0iMTIiIHkxPSI5IiB4Mj0iMTIiIHkyPSIxMyI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjE3IiB4Mj0iMTIuMDEiIHkyPSIxNyI+PC9saW5lPjwvc3ZnPg==';
  }

  showRedirectModal() {
    let config = {};
    try {
      const configData = document.body?.getAttribute('data-ip-modal-config');
      if (configData) {
        config = JSON.parse(configData);
      } else if (window.ipModalConfig) {
        config = window.ipModalConfig;
      }
    } catch (e) {
      if (window.ipModalConfig) {
        config = window.ipModalConfig;
      }
    }
    
    const title = config.title || 'SELECT YOUR STORE';
    const description = config.description || 'Seems like you are on a different store compared to your location. Which store would you like to shop?';
    const titleColor = config.titleColor || '#388AA9';
    const titleFontSize = config.titleFontSize || 20;
    const descriptionFontSize = config.descriptionFontSize || 16;
    const buttonFontSize = config.buttonFontSize || 16;
    const mobileTitleFontSize = config.mobileTitleFontSize || 16;
    const mobileDescriptionFontSize = config.mobileDescriptionFontSize || 13;
    const mobileButtonFontSize = config.mobileButtonFontSize || 11;
    
    const currentSiteName = this.currentSite?.name || 'current';
    const currentSiteLogo = this.getCurrentSiteLogo();
    
    const targetSiteName = this.targetCountry?.name || 'local';
    const targetSiteLogo = this.targetCountry?.logo || currentSiteLogo;
    const targetSiteCountryName = this.targetCountry?.country_name || 'local';
    
    const modal = document.createElement('modal-dialog');
    modal.className = 'modal ip-modal';
    modal.id = 'ip-check-modal';
    
    const style = document.createElement('style');
    style.id = 'ip-modal-dynamic-styles';
    style.textContent = `
      #ip-check-modal .ip-modal-title h3 {
        font-size: ${titleFontSize}px !important;
        color: ${titleColor} !important;
      }
      #ip-check-modal .ip-modal-title p {
        font-size: ${descriptionFontSize}px !important;
      }
      #ip-check-modal .ip-modal-btn {
        font-size: ${buttonFontSize}px !important;
      }
      
      @media (max-width: 768px) {
        #ip-check-modal .ip-modal-title h3 {
          font-size: ${mobileTitleFontSize}px !important;
          color: ${titleColor} !important;
        }
        #ip-check-modal .ip-modal-title p {
          font-size: ${mobileDescriptionFontSize}px !important;
        }
        #ip-check-modal .ip-modal-btn {
          font-size: ${mobileButtonFontSize}px !important;
        }
      }
    `;
    
    const existingStyle = document.getElementById('ip-modal-dynamic-styles');
    if (existingStyle) {
      existingStyle.remove();
    }
    
    document.head.appendChild(style);
    
    modal.innerHTML = `
      <div class="ip-modal-container">
        <div class="ip-modal-content">          
          <div class="ip-modal-main">
            <div class="ip-modal-right">
              <div class="ip-modal-title">
                <h3>${title}</h3>
                <p>${description}</p>
              </div>

              <div class="ip-modal-actions">
                <button class="ip-check-cancel-btn ip-modal-btn ip-modal-btn-white">
                  ${currentSiteLogo ? `
                    <div class="ip-modal-btn-logo">
                      <img src="${currentSiteLogo}" alt="${currentSiteName} logo">
                    </div>
                  ` : ''}
                  <span class="ip-modal-btn-text">${(this.currentSite?.country_name || currentSiteName).toUpperCase()}</span>
                </button>
                <button class="ip-check-confirm-btn ip-modal-btn ip-modal-btn-white">
                  ${targetSiteLogo ? `
                    <div class="ip-modal-btn-logo">
                      <img src="${targetSiteLogo}" alt="${targetSiteCountryName} logo">
                    </div>
                  ` : ''}
                  <span class="ip-modal-btn-text">${(targetSiteCountryName || targetSiteName).toUpperCase()}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    const confirmBtn = modal.querySelector('.ip-check-confirm-btn');
    const cancelBtn = modal.querySelector('.ip-check-cancel-btn');

    const closeModal = (userAction) => {
      if (!userAction) {
        this.setDataWithExpiry();
      }

      modal.removeAttribute('open');

      document.body.style.top = '';
      document.body.classList.remove('fixed');
      if (modal.scrollY !== undefined) {
        window.scrollTo(0, modal.scrollY);
      }
      
      setTimeout(() => {
        if (modal.parentNode) {
          modal.parentNode.removeChild(modal);
        }
      }, 300);
    };
    
    if (confirmBtn) {
      confirmBtn.addEventListener('click', () => {
        closeModal('confirm');
        const url = this.targetCountry.url;
        const path = url.includes('/') ? '' : '/';
        window.location.href = `https://www.${url}${path}`;
      });
    }
    
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        this.setDataWithExpiry();
        closeModal('cancel');
      });
    }
    
    try {
      modal.open();
    } catch (error) {
      console.error('Failed to open modal:', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const ipCheck = new IpCheck();
  ipCheck.init(window.Shopify || {});
});
